export const SET_LOADING = 'SET_LOADING';
export const GET_ALL_PERMISSION_GROUPS = 'GET_ALL_PERMISSION_GROUPS';
export const ATTACH_PERMISSION_TO_ROLE = 'ATTACH_PERMISSION_TO_ROLE';
export const DETACH_PERMISSION_FROM_ROLE = 'DETACH_PERMISSION_FROM_ROLE';
export const RESET_PERMITIONS_TO_ROLE = 'RESET_PERMITIONS_TO_ROLE';
export const SET_GROUPS = 'SET_GROUPS';
export const SET_ROLES = 'SET_ROLES';
export const GET_GROUPS = 'GET_GROUPS';
export const GET_ROLES = 'GET_ROLES';
